<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-card title="请求参数" :bordered="false">
          <a-col :span="24">
            <a-form-model-item label="api类型" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="apiType">
<!--              <a-input v-model="model.apiType" placeholder="请输入api类型"  ></a-input>-->
              <j-dict-select-tag type="radio" v-model="model.apiType" :trigger-change="true" dictCode="hhemp_aicsp_apitype" :disabled="formDisabled"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="category" :labelCol="labelCol1" :wrapperCol="wrapperCol1" prop="category">
              <!--              <a-input v-model="model.category" placeholder="请输入category"  ></a-input>-->
              <j-dict-select-tag type="radio" v-model="model.category" :trigger-change="true" dictCode="hhemp_aicsp_category" :disabled="formDisabled"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="lang" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="lang">
              <!--              <a-input v-model="model.lang" placeholder="请输入lang"  ></a-input>-->
              <j-dict-select-tag type="radio" v-model="model.lang" :trigger-change="true" dictCode="hhemp_aicsp_lang" :disabled="formDisabled"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8" v-if="model.apiType==='chatWithKnowledge'||model.apiType==='cspChatWithKnowledge'">
            <a-form-model-item label="convertTextToSpeech" :labelCol="labelCol2" :wrapperCol="wrapperCol2" prop="convertTextToSpeech">
              <!--              <a-input v-model="model.convertTextToSpeech" placeholder="请输入convertTextToSpeech"  ></a-input>-->
              <j-dict-select-tag type="radio" v-model="model.convertTextToSpeech" :trigger-change="true" dictCode="hhemp_isthird" :disabled="formDisabled"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24" v-if="model.id">
            <a-form-model-item label="操作用户账号" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="userid">
              <a-input v-model="model.userid" placeholder="请输入操作用户账号"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24" v-if="model.id">
            <a-form-model-item label="操作用户名称" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="username">
              <a-input v-model="model.username" placeholder="请输入操作用户名称"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24" v-if="model.id">
            <a-form-model-item label="请求java方法" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="method">
              <a-input v-model="model.method" placeholder="请输入请求java方法"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="content" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="content">
              <a-textarea v-model="model.content" maxLength="1000" rows="4" placeholder="请输入content"  ></a-textarea>
            </a-form-model-item>
          </a-col>

          <a-col :span="24" v-if="model.id">
            <a-form-model-item label="请求路径" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="requestUrl">
              <a-input v-model="model.requestUrl" placeholder="请输入请求路径"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24" v-if="model.id">
            <a-form-model-item label="请求参数" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="requestParam">
              <a-textarea v-model="model.requestParam" rows="4" placeholder="请输入请求参数" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24" v-if="model.id">
            <a-form-model-item label="请求类型" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="requestType">
              <a-input v-model="model.requestType" placeholder="请输入请求类型"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24" v-if="model.id">
            <a-form-model-item label="耗时" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="costTime">
              <a-input-number v-model="model.costTime" placeholder="请输入耗时" style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24" v-if="model.id">
            <a-form-model-item label="响应结果" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="responseResult">
              <a-textarea v-model="model.responseResult" rows="4" placeholder="请输入响应结果" />
            </a-form-model-item>
          </a-col>
          </a-card>
        </a-row>
        <a-row>
          <a-card title="响应参数" :bordered="false">
            <a-col :span="24" v-if="(model.apiType==='chatWithKnowledge'||model.apiType==='cspChatWithKnowledge')&&model.responseResult">
              <a-form-model-item label="回答" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="responseResult">
                <a-textarea v-model="JSON.parse(model.responseResult).content" rows="5" disabled="true" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24" >
              <a-form-model-item label="响应结果" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="responseResult">
                <a-textarea v-model="model.responseResult" rows="10" disabled="true" />
              </a-form-model-item>
            </a-col>
<!--            <a-col :span="24" >
              <div v-if="model.responseResult&&JSON.parse(model.responseResult).content">
                <a-button type="link" @click="showModal(model.responseResult)">查看</a-button>
              </div>
            </a-col>-->
            <a-col :span="24" >
              <div v-if="model.convertTextToSpeech==='1'">
                <a-form-model-item label="Audio" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="responseResult">
                <audio ref="audioElement" controls></audio>
                </a-form-model-item>
              </div>
            </a-col>
          </a-card>
        </a-row>
        <a-row>
          <a-col :span="20" >
          </a-col>
          <a-col :span="4" >
            <a-button @click="reset" icon="reload" style="margin-right: 8px;right: 10px">重置</a-button>
          </a-col>
        </a-row>
      </a-form-model>

    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'EmpAicspLogForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol1: {
          xs: { span: 24 },
          sm: { span: 18},
        },
        wrapperCol1: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 8},
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 10 },
        },
        confirmLoading: false,
        validatorRules: {
           delFlag: [
              { required: true, message: '请输入删除标准!'},
           ],
          apiType: [
            { required: true, message: '请选择apiType!'},
          ],
          category: [
            { required: true, message: '请选择category!'},
          ],
          lang: [
            { required: true, message: '请选择lang!'},
          ],
          convertTextToSpeech: [
            { required: true, message: '请选择convertTextToSpeech!'},
          ],
          content: [
            { required: true, message: '请输入content!'},
          ],
        },
        url: {
          add: "/hhemp/aicsp/empaicsplog",
          edit: "/hhemp/aicsp/empaicsplog",
          queryById: "/hhemp/aicsp/empaicsplog/"
        },
        audioSrc: '',
        isModalVisible: false,
        modalText: '',
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit({apiType:'cspChatWithKnowledge',category:'hhemp',lang:'tw',convertTextToSpeech:'0'});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      reset(){
        this.model = Object.assign({}, {apiType:'cspChatWithKnowledge',category:'hhemp',lang:'tw',convertTextToSpeech:'0'});
        this.audioSrc = '';
        this.model.id = '';
        this.isModalVisible = false;
        this.modalText = '';
        this.$refs.audioElement.src = '';
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.model.responseResult = res.result.responseResult;
                that.model.id = '';
                try{
                  that.audioSrc = "data:audio/wav;base64,"+JSON.parse(res.result.responseResult).base64Audio;
                  that.$refs.audioElement.src = that.audioSrc;
                }catch (e) {

                }
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      // 显示模态框
      showModal(record) {
        this.modalText = JSON.parse(record).content;
        this.isModalVisible = true;
      },

      // 处理模态框确认
      handleOk() {
        this.isModalVisible = false;
        this.modalText = '';
      },

      // 处理模态框取消
      handleCancel() {
        this.isModalVisible = false;
        this.modalText = '';
      },
    }
  }
</script>
